if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
      }
      
      connectedCallback() {
        // cutom dev
        // localStorage.removeItem("selectedSize");
        
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

        const firstHeightOpt = document.querySelector(".product-form__input.height .height_option");
        if(firstHeightOpt){
          firstHeightOpt.classList.add('active');
          document.querySelector(".custom-size-inputbox [name='custom-height']").value = firstHeightOpt.getAttribute("data-value");
          localStorage.setItem("selectedHeight", firstHeightOpt.getAttribute("data-value"));
        }
        
        // console.log("firstHeight",firstHeight);
        localStorage.removeItem("customSize");
        localStorage.removeItem("selectedHeight");
        localStorage.removeItem("selectedSize");
        
        this.sizeElems();
        var currentVariant = document.querySelector(".cst-product-slider-wrapper .pdp-main-slider-wrap")?.getAttribute("data-seleted-alt");
        // console.log("on load variant",currentVariant);
        this.cstUpdateMedia(currentVariant);
      
        var stickyBarVariant = document.querySelector(".product-main-sticky-bar .product-sticky-variant");
        const customDropdownLabel = document.querySelector(".custom-dropdown-button-text");
        if(stickyBarVariant && customDropdownLabel){
          const heightOption = document.querySelector(".variant-pill-list.height");
          if(heightOption){
            customDropdownLabel.removeAttribute("data-selected");
            const spanElement = document.createElement("span");
            spanElement.textContent = 'Select a Size!';
            spanElement.style.color = 'red';
            stickyBarVariant.replaceChildren(spanElement);
            document.querySelector(".product-main-sticky-bar .sticky-addtocart-btn .btn-text").textContent = 'Select a Size';
          }
        }
         
        // custom dev
        var heightOptions = document.querySelectorAll(".product-form__input.height .height_option:not(.hidden)");
        const currentUrl = window.location.href;
        if (heightOptions.length > 0) {
          if (currentUrl.includes("6-inch")) {
           heightOptions.forEach(heightOpt=>{
             var heightVal = heightOpt.getAttribute("data-value");
             if(heightVal == 6){
                heightOpt.dataset.trigger = "true";  // Set the trigger attribute
                heightOpt.click();  // Simulate the click
             }
           })
          }else if (currentUrl.includes("8-inch")) {
            heightOptions.forEach(heightOpt=>{
              var heightVal = heightOpt.getAttribute("data-value");
              if(heightVal == 8){
                heightOpt.dataset.trigger = "true";  // Set the trigger attribute
                heightOpt.click();  // Simulate the click
              }
            })
          }else if (currentUrl.includes("10-inch")) {
           heightOptions.forEach(heightOpt=>{
             var heightVal = heightOpt.getAttribute("data-value");
             if(heightVal == 10){
                heightOpt.dataset.trigger = "true";  // Set the trigger attribute
                heightOpt.click();  // Simulate the click
             }
           })
          }
          // else {
          //   console.log("heightOptions",heightOptions);
          //   const firstVisibleHeight = document.querySelector(".product-form__input.height .height_option:not(.hidden)");
          //   firstVisibleHeight.dataset.trigger = "true"; 
          //   firstVisibleHeight.click();
          // }
        
          // Set the data-trigger attribute before programmatically clicking the first option          
        }
        this.sizeConverter();
        this.customSize();
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      sizeElems(){
        const _this = this;
        var defaultBuyButton = document.querySelector(".buy-buttons-block");
        var stickyBar = document.querySelector(".product-main-sticky-bar");
         var stickyBarButton = stickyBar.querySelector(".sticky-addtocart-btn .btn-text")
        // START ---- Product page custom size dropdown
         var stickyBarVariant = stickyBar.querySelector(".product-sticky-variant");
        const quantityButtons = document.querySelectorAll(".product__info-wrapper .quantity__button");
        
        var productInfoElem = document.querySelector(".custom-dropdown-button-text");
        var customSizeDropdown = document.querySelector(".dimension-custom-dropdown");
        
        if(customSizeDropdown){
          if(productInfoElem.textContent == 'Select a Size'){
            defaultBuyButton.classList.remove('active');
            // stickyBarButton.textContent = 'Select Size';
            quantityButtons.forEach(qtyBtn=>{
              qtyBtn.classList.add('disabled');
              qtyBtn.setAttribute('disabled','disabled');
            });
          }else{
            const dd_hide = document.querySelector(".addOnProducts-wrapper.hidden");
            if (dd_hide){
              dd_hide.classList.remove("hidden");
            }
          }
                 
          var customSizeElems = customSizeDropdown.querySelectorAll(".dimension_wrapper .dimension_val");
         
          var filteredSizeElems = [...customSizeElems].filter(elem => 
              !elem.classList.contains("hidden") && !elem.hasAttribute("disabled")
          );
          filteredSizeElems.forEach((sizeElem) => {
            sizeElem.addEventListener('click', function() {
              var selectedSize = this.getAttribute("data-value");
              // console.log("selectedSize >>> ",selectedSize);
               document.querySelector(".product-form__input.dimension input[value='" + selectedSize + "']")?.click();
              quantityButtons.forEach(qtyBtn=>{
                qtyBtn.classList.remove('disabled');
                qtyBtn.removeAttribute('disabled','disabled');
              });
              
              const dd_hide = document.querySelector(".addOnProducts-wrapper.hidden");
              if (dd_hide){
                dd_hide.classList.remove("hidden");
              }
              
              localStorage.setItem("selectedSize", selectedSize);
              productInfoElem.textContent = selectedSize + ' inches';
              defaultBuyButton.classList.add('active');
              const stickyBtnText = stickyBarButton.getAttribute("data-text");
              // stickyBarButton.textContent = 'Add To Cart';
              stickyBarButton.textContent = stickyBtnText;
          
              var selectedHeightOption = document.querySelector(".height_option.active");
              if (selectedHeightOption) {
                  localStorage.setItem("selectedHeight", selectedHeightOption.getAttribute("data-value"));
              }
             
              document.querySelector(".product-form__input.dimension-size input[value='" + selectedSize + "']")?.click();
            });
          });
          
          customSizeDropdown.querySelector(".custom-dropdown-button")?.addEventListener('click',function(){
            this.classList.toggle('active');
          });
        }else{
          const dd_hide = document.querySelector(".addOnProducts-wrapper.hidden");
          if (dd_hide){
            dd_hide.classList.remove("hidden");
          }
        }


         var heightOptions = document.querySelectorAll(".product-form__input.height .height_option");
        if(heightOptions.length){
          heightOptions.forEach((heightOption)=>{
            heightOption.addEventListener('click',function(){
              console.log("Height Option Clicked...");
              heightOptions.forEach((heightOption)=>{
                heightOption.classList.remove("active");
              });
              this.classList.add('active');
              var heightVal = this.getAttribute("data-value");
                        localStorage.setItem("selectedHeight", heightVal);
              const customHeightInput = document.querySelector(".custom-size-wrapper .height-option input");
              // console.log("customHeightInput",customHeightInput);
              if(customHeightInput) customHeightInput.value = heightVal;
              _this.customSize();
              
              //remove rrormsg on heightOption selection
              var existingError = document.querySelector(".size-selection-error");
              if (existingError) {
                  existingError.remove(); // Remove the error message completely
              }
              //delivery msg For size select
              const delpicMsg = document.querySelector(".delivery_input_main span#delpicMsg");
              if (delpicMsg) {
                delpicMsg.innerHTML = "";
              }
              
              hideDimension(heightVal,false);
              if (!this.dataset.trigger) {
                productInfoElem.removeAttribute("data-selected");
                // console.log("select a size sets");
                productInfoElem.textContent = "Select a Size"; // Reset size selection
                quantityButtons.forEach(qtyBtn=>{
                  qtyBtn.classList.add('disabled');
                  qtyBtn.setAttribute('disabled','disabled');
                });
                
                const dd_hide = document.querySelector(".addOnProducts-wrapper");
                if (dd_hide){
                  dd_hide.classList.add("hidden");
                }

                const isCustomSizeActive = document.querySelector(".variant-pill-list-wrap .custom-size.active");
                
                if(isCustomSizeActive){
                  
                }else{
                 // set text to varinat sticky bar on pdp page
                  const spanElement = document.createElement("span");
                  spanElement.textContent = 'Select a Size!';
                  spanElement.style.color = 'red';
                  
                  stickyBarVariant.replaceChildren(spanElement);
                  // set text to varinat sticky bar on pdp page
                  defaultBuyButton.classList.remove('active');
                  stickyBarButton.textContent = 'Select Size'; 
                  localStorage.removeItem("selectedSize");
                }
              }
              // Remove the data-trigger after execution so future clicks behave normally
              this.removeAttribute("data-trigger"); // Reset the attribute
            });
            
          });
        }
          _this.customSize();
        var selectedHeightElem = document.querySelector(".height_option.active");
        console.log("selectedHeightElem",selectedHeightElem);
        if(selectedHeightElem){
          var selectedHeightval = selectedHeightElem.getAttribute("data-value");
          hideDimension(selectedHeightval,true);
        }
        function hideDimension(heightVal,onpageLoad){
          filteredSizeElems.forEach((sizeElem) => {
            var size_value = sizeElem.getAttribute("data-value");
        
            if (size_value) {  
              let parts = size_value.split(" x ");
              let lastValue = parseInt(parts[parts.length - 1], 10);
              // console.log("lastValue", lastValue);
      
              if (heightVal == lastValue) {
                sizeElem.classList.remove('hidden');
              } else {
                sizeElem.classList.add('hidden');
              }
            } else {
                console.log("Skipping element, no data-value attribute.");
            }
          });
          const visibleDimensionInputs = document.querySelectorAll(
              '.dimension .variant-pill:not(.hidden) input[type="radio"]'
            );
      
              // console.log("visibleDimensionInputs",visibleDimensionInputs);
              // 2. Extract unique height values from dimension inputs
              const heightSet = new Set();
            
              visibleDimensionInputs.forEach(input => {
                const value = input.value.trim(); // "78 x 36 x 10"
                const parts = value.split("x").map(p => p.trim());
                const height = parts[parts.length - 1]; // Get "10"
                if (height) {
                  heightSet.add(height);
                }
              });
              // console.log("heightSet",heightSet);
              var heightOptions = document.querySelectorAll(".product-form__input.height .height_option");
              heightOptions.forEach(option => {
                const value = option.getAttribute("data-value");
                if (heightSet.has(value)) {
                  option.closest(".variant-pill").classList.remove("hidden");
                  option.classList.remove("hidden");
                } else {
                  option.classList.add("hidden");
                  option.closest(".variant-pill").classList.add("hidden");
                }
              });
         

          if (selectedHeightElem && selectedHeightElem.classList.contains("hidden") && onpageLoad) {
            console.warn("Active height option is now hidden. Clicking first visible one...");
          
            const firstVisible = document.querySelector(".product-form__input.height .height_option:not(.hidden)");
            if (firstVisible) {
              firstVisible.dataset.trigger = "true";
              firstVisible.click();
            }
          }
        }
        
        // END ---- Product page custom size dropdown

         // product page heightOption Tooltip
        const heightTooltip = document.querySelector(".product-form__input.height .tooltip-title");
        if(heightTooltip){
          heightTooltip.addEventListener('click',function(){
            this.classList.toggle('active');
          });
        }
        document.addEventListener('click', function(event) {
          if (
            !event.target.closest('.tooltip-button') &&
            !event.target.closest('.tooltip-popup')
          ) {
            heightTooltip?.classList.remove('active'); // Replace with the actual class you want to remove
          }
        });
      }

      sizeConverter(){
         var customSizeDropdown = document.querySelector(".dimension-custom-dropdown");

        var converterButtons = document.querySelectorAll(".converter_wrapper .convert");
        
        if (converterButtons.length) {
          converterButtons.forEach((btn) => {
            btn.addEventListener("click", function (e) {
              e.preventDefault();
        
              // Remove active from all, add to clicked
              converterButtons.forEach((elemBtn) => elemBtn.classList.remove("active"));
              btn.classList.add("active");
        
              if (customSizeDropdown) {
                var customSizeElems = customSizeDropdown.querySelectorAll(".dimension_wrapper .dimension_val");
        
                var filteredSizeElems = [...customSizeElems].filter(elem =>
                  !elem.classList.contains("hidden") && !elem.hasAttribute("disabled")
                );
        
                var selectedDimension = customSizeDropdown.querySelector(".dimension_val[selected='selected']");
                var selectedValElement = customSizeDropdown.querySelector(".custom-dropdown-button-text");
                if (!selectedDimension) return;
        
                var selectedSizeVal = selectedValElement.getAttribute("data-selected");
        
                // Extract label and dimensions from selected
                let selectedLabel = "";
                let selectedRawVal = selectedSizeVal;
                if (selectedSizeVal && selectedSizeVal.includes("-")) {
                  const parts = selectedSizeVal.split("-");
                  selectedLabel = parts[0].trim();
                  selectedRawVal = parts.slice(1).join("-").trim();
                }
        
                let convertedVal = selectedSizeVal; // fallback
        
                filteredSizeElems.forEach((sizeElem) => {
                  var size_val = sizeElem.getAttribute("data-value");
                  if (!size_val) return;
        
                  // Extract label and raw dimension
                  let label = "";
                  let raw_val = size_val;
                  if (size_val.includes("-")) {
                    const parts = size_val.split("-");
                    label = parts[0].trim();
                    raw_val = parts.slice(1).join("-").trim();
                  }
        
                  let converted_val = raw_val;
                  let unit = "";
        
                  // Convert to CM
                  if (btn.classList.contains("convert_cm")) {
                    unit = "cm";
                    converted_val = raw_val
                      .split("x")
                      .map(v => (parseFloat(v.trim()) * 2.54).toFixed(1))
                      .join(" x ");
                    sizeElem.textContent = label ? `${label} - ${converted_val}` : `${converted_val}`;
                    if (raw_val === selectedRawVal) {
                      convertedVal = label ? `${label} - ${converted_val} ${unit}` : `${converted_val} ${unit}`;
                    }
                  }
        
                  // Convert to Feet
                  else if (btn.classList.contains("convert_feet")) {
                    unit = "feet";
                    converted_val = raw_val
                      .split("x")
                      .map(v => {
                        let feet = parseFloat(v.trim()) / 12;
                        return feet.toFixed(2).replace(/\.0+$/, '').replace(/(\.\d)0+$/, '$1');
                      })
                      .join(" x ");
                    sizeElem.textContent = label ? `${label} - ${converted_val}` : `${converted_val}`;
                    if (raw_val === selectedRawVal) {
                      convertedVal = label ? `${label} - ${converted_val} ${unit}` : `${converted_val} ${unit}`;
                    }
                  }
        
                  // Reset to Inches
                  else if (btn.classList.contains("convert_inch")) {
                    unit = "inches";
                    sizeElem.textContent = size_val;
                    if (size_val === selectedSizeVal) {
                      convertedVal = size_val + " " + unit;
                    }
                  }
                });
        
                // Set final selected display
                if (convertedVal) {
                  const labelval = selectedValElement.textContent;
                  console.log("labelval",labelval);
                    if (labelval !== "Select a Size") {
                      selectedValElement.textContent = convertedVal;
                    }
                    // selectedValElement.textContent = convertedVal;
                  
                  
                } else {
                  selectedValElement.textContent = 'Select a Size';
                  const dd_hide = document.querySelector(".addOnProducts-wrapper");
                  if (dd_hide) {
                    dd_hide.classList.add("hidden");
                  }
                }
        
              } else {
                // No dropdown fallback
                const sizeElem = document.querySelector(".dimension.noDropdown .dimension_val");
                if (sizeElem) {
                  let size_val = sizeElem.getAttribute("data-value");
                  if (size_val) {
                    let label = "";
                    let raw_val = size_val;
                    if (size_val.includes("-")) {
                      const parts = size_val.split("-");
                      label = parts[0].trim();
                      raw_val = parts.slice(1).join("-").trim();
                    }
        
                    let parts = raw_val.split("x").map(v => parseFloat(v.trim()));
                    let convertedVal = raw_val;
                    let unit = "";
        
                    if (btn.classList.contains("convert_cm")) {
                      unit = "cm";
                      convertedVal = parts.map(v => (v * 2.54).toFixed(1)).join(" x ");
                      sizeElem.textContent = label ? `${label} - ${convertedVal} ${unit}` : `${convertedVal} ${unit}`;
                    } else if (btn.classList.contains("convert_feet")) {
                      unit = "feet";
                      convertedVal = parts.map(v => {
                        let feet = v / 12;
                        return feet.toFixed(2).replace(/\.0+$/, '').replace(/(\.\d)0+$/, '$1');
                      }).join(" x ");
                      sizeElem.textContent = label ? `${label} - ${convertedVal} ${unit}` : `${convertedVal} ${unit}`;
                    } else if (btn.classList.contains("convert_inch")) {
                      unit = "inches";
                      sizeElem.textContent = size_val + " " + unit;
                    }
                  }
                }
              }
            });
          });
        }

        // END --- Product page inch to cm,feet converter
      }

      customSize(){
        const existingInput = document.querySelector("#custom_size");
        if (existingInput) {
          existingInput.remove(); // Remove it if found
        }
        //execute if customSize active 
        function isCustomSize(){

          function restrictToNumericInput(inputElement) {
            inputElement.addEventListener("keydown", function (e) {
              const allowedKeys = [
                "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab",
              ];
          
              // Allow number keys (0–9) and allowed control keys
              if (
                (e.key >= "0" && e.key <= "9") ||
                allowedKeys.includes(e.key)
              ) {
                return; // Allow input
              } else {
                e.preventDefault(); // Block anything else (e.g., letters, symbols, etc.)
              }
            });
          }
          const defaultBuyButton = document.querySelector(".buy-buttons-block");
          const isCustomActive = document.querySelector(".custom-size.active");
          const pincodeInput = document.querySelector(".pincode-wrapper input[id='pincode']");
          const customWrapper = document.querySelector(".custom-size-wrapper");
          const customBuyButton = document.querySelector(".product__info-wrapper .custom_buy_button");
          // console.log("isCustomActive",isCustomActive);
          
          var dimensionOptions = document.querySelector(".product_customDropdown");
          if(isCustomActive){
            if(defaultBuyButton) defaultBuyButton.classList.remove("active");
            if(pincodeInput) pincodeInput.setAttribute("data-custom",true);
            customWrapper.classList.remove("hidden");
            const inputs = document.querySelectorAll('.variant-pill-list input[type="radio"]');
            inputs.forEach(input => {
              input.checked = false;
            });
            const cstbtntext = document.querySelector(".sticky-addtocart-btn .btn-text");
            // console.log("cstbtntext >>> ",cstbtntext);
            if(cstbtntext){
              cstbtntext.textContent = "Add to Cart"
            }
            if(dimensionOptions){
              dimensionOptions.classList.add('hidden');
            }

            var lengthInput = document.querySelector("input[name='custom-length']");
            var widthInput = document.querySelector("input[name='custom-width']");
            var heightInput = document.querySelector("input[name='custom-height']");
            if(heightInput){
              const heightValue = heightInput.value;
            }
            if (lengthInput) restrictToNumericInput(lengthInput);
            if (widthInput) restrictToNumericInput(widthInput);
            if (heightInput) restrictToNumericInput(heightInput); // Only if enabled later
            
            // const MIN_LENGTH = 60;
            // const MAX_LENGTH = 84;
            // const MIN_WIDTH = 24;
            // const MAX_WIDTH = 78;

            const MIN_LENGTH = Number(lengthInput.getAttribute('min')) || 60;
            const MAX_LENGTH = Number(lengthInput.getAttribute('max')) || 84;
            const MIN_WIDTH = Number(widthInput.getAttribute('min')) || 24;
            const MAX_WIDTH = Number(widthInput.getAttribute('max')) || 78;
            
            const showError = (message) => {
              console.log("message",message);
              const errorWrapper = document.querySelector(".error-msg-wrapper");
              const atcBtns = document.querySelectorAll(".atc-button");
              const stickyBar = document.querySelector(".product-main-sticky-bar");
              const cst_priceElem = document.querySelector(".product__info-wrapper .price");
              console.log("cst_priceElem",cst_priceElem);
              if (errorWrapper) {
                atcBtns.forEach((atcBtn)=>{
                  atcBtn.classList.add('hidden');
                });
                if(cst_priceElem){
                  cst_priceElem.classList.add('hidden');
                }
                stickyBar.classList.add("hidden");
                errorWrapper.textContent = message;
              }
            };

            const handleCustomChange = () => {
              const lengthValue = parseInt(lengthInput.value.trim(), 10);
              const widthValue = parseInt(widthInput.value.trim(), 10);
              const heightValue = heightInput?.value.trim();
              const errorWrapper = document.querySelector(".error-msg-wrapper");
              const atcBtns = document.querySelectorAll(".atc-button");
              const stickyBar = document.querySelector(".product-main-sticky-bar");
              const cst_priceElem = document.querySelector(".product__info-wrapper .price");
            
              // Validate length
              if (isNaN(lengthValue) || lengthValue < MIN_LENGTH || lengthValue > MAX_LENGTH) {
                showError(`Length customization is allowed between ${MIN_LENGTH} - ${MAX_LENGTH} inch`);
                return;
              }
            
              // Validate width
              if (isNaN(widthValue) || widthValue < MIN_WIDTH || widthValue > MAX_WIDTH) {
                showError(`Width customization is allowed between ${MIN_WIDTH} - ${MAX_WIDTH} inch`);
                return;
              }
            
              if (errorWrapper) {
                errorWrapper.textContent = '';
              }
              atcBtns.forEach((atcBtn) => atcBtn.classList.remove('hidden'));
              if (cst_priceElem) cst_priceElem.classList.remove('hidden');
              stickyBar.classList.remove('hidden');
            
              const customDimensionVal = `${lengthValue} x ${widthValue} x ${heightValue}`;
              const matchedDimensions = [];
              const allDimensionElems = document.querySelectorAll(".dimension_wrapper .dimension_val");
            
              allDimensionElems.forEach((dimensionElem) => {
                const dimensionval = dimensionElem.getAttribute("data-value");
                const parts = dimensionval.split(/x|X/).map(p => p.trim());
                if (parts.length === 3 && parts[2] === heightValue) {
                  matchedDimensions.push(dimensionval);
                }
              });
            
              const [customL, customW, customH] = customDimensionVal.split(/x|X/).map(p => parseInt(p.trim(), 10));
              const allAvailableDimensions = matchedDimensions.map(dim => {
                const [l, w, h] = dim.split(/x|X/).map(p => parseInt(p.trim(), 10));
                return { length: l, width: w, height: h, raw: dim };
              });
            
              const sameHeightDims = allAvailableDimensions.filter(dim => dim.height === customH);
              let possibleLengths = sameHeightDims.map(dim => dim.length).filter(l => l >= customL).sort((a, b) => a - b);
              let possibleWidths = sameHeightDims.map(dim => dim.width).filter(w => w >= customW).sort((a, b) => a - b);
            
              let matchedDimObj = null;
              outerLoop:
              for (let l of possibleLengths) {
                for (let w of possibleWidths) {
                  for (let dim of sameHeightDims) {
                    if (dim.length === l && dim.width === w) {
                      matchedDimObj = dim;
                      break outerLoop;
                    }
                  }
                }
              }
            
              if (!matchedDimObj && sameHeightDims.length > 0) {
                matchedDimObj = sameHeightDims.reduce((closest, dim) => {
                  const diff = Math.abs(dim.length - customL) + Math.abs(dim.width - customW);
                  const closestDiff = Math.abs(closest.length - customL) + Math.abs(closest.width - customW);
                  return diff < closestDiff ? dim : closest;
                }, sameHeightDims[0]);
              }
            
              const product_sticky_variant = document.querySelector(".product-sticky-variant");
              let finalDimension;
              if (matchedDimObj) {
                const isExactMatch =
                  matchedDimObj.length === customL &&
                  matchedDimObj.width === customW &&
                  matchedDimObj.height === customH;
            
                finalDimension = `${matchedDimObj.length} x ${matchedDimObj.width} x ${matchedDimObj.height}`;
            
                const existingInput = document.querySelector("#custom_size");
                if (existingInput) existingInput.remove();
            
                if (isExactMatch) {
                  if (product_sticky_variant) {
                    product_sticky_variant.textContent = `${customDimensionVal} inches`;
                  }
                } else {
                  if (product_sticky_variant) {
                    product_sticky_variant.textContent = `Custom | ${customDimensionVal} inches`;
                  }
            
                  const hiddenInput = document.createElement("input");
                  hiddenInput.type = "hidden";
                  hiddenInput.id = "custom_size";
                  hiddenInput.name = "properties[custom_size]";
                  hiddenInput.value = `${customDimensionVal} inches`;
                  customBuyButton.setAttribute("data-size",customDimensionVal + ' inches');
                  document.querySelector("product-form form").appendChild(hiddenInput);
                }
            
                const productDataEl = document.getElementById('ProductJson');
                let product = null;
            
                if (productDataEl) {
                  try {
                    product = JSON.parse(productDataEl.textContent);
                  } catch (e) {
                    console.error("Failed to parse product JSON:", e);
                  }
                }
            
                if (product && product.variants) {
                  const dimensionIndex = product.options.findIndex(opt => opt.toLowerCase() === "dimension");
                  if (dimensionIndex === -1) {
                    console.warn("No 'Dimension' option found in product.options.");
                    return;
                  }
            
                  const getVariantByDimension = (dimString) => {
                    return product.variants.find(v => v.options[dimensionIndex] === dimString);
                  };
            
                  let matchedVariant = getVariantByDimension(finalDimension);
            
                  if (matchedVariant && matchedVariant.available) {
                    updateVariantDetails(matchedVariant);
                  } else if (isExactMatch) {
                  if (errorWrapper) {
                      // errorWrapper.textContent = "Oops! Sorry it looks like the selected size is not available currently. Please feel free to contact our sleep experts for more assistance.";
                    showError("Oops! Sorry it looks like the selected size is not available currently. Please feel free to contact our sleep experts for more assistance.");
                  }
                    return;
                   
                  } else {
                    const availableAlternatives = sameHeightDims
                      .filter(dim => {
                        const variant = getVariantByDimension(`${dim.length} x ${dim.width} x ${dim.height}`);
                        return variant && variant.available;
                      })
                      .sort((a, b) => {
                        const diffA = Math.abs(a.length - customL) + Math.abs(a.width - customW);
                        const diffB = Math.abs(b.length - customL) + Math.abs(b.width - customW);
                        return diffA - diffB;
                      });
            
                    if (availableAlternatives.length > 0) {
                      const altDim = availableAlternatives[0];
                      finalDimension = `${altDim.length} x ${altDim.width} x ${altDim.height}`;
                      matchedVariant = getVariantByDimension(finalDimension);
            
                      if (product_sticky_variant) {
                        product_sticky_variant.textContent = `Closest match | ${finalDimension} inches`;
                      }
            
                      const hiddenInput = document.createElement("input");
                      hiddenInput.type = "hidden";
                      hiddenInput.id = "custom_size";
                      hiddenInput.name = "properties[custom_size]";
                      hiddenInput.value = `${customDimensionVal} inches`;
                      document.querySelector("product-form form").appendChild(hiddenInput);
            
                      updateVariantDetails(matchedVariant);
                    } else {
                      alert("Sorry! No available sizes match your custom dimensions at this time.");
                      return;
                    }
                  }
                }
              }
            };
            
            // ✅ Helper function to update variant price, ID, and discount
            function updateVariantDetails(matchedVariant) {
              const product_form_input = document.querySelector("product-form input[name='id']");
              product_form_input.value = matchedVariant.id;
              customBuyButton.setAttribute("data-variant-id",matchedVariant.id);
            
              const orig_price = document.querySelector(".price__sale .price-item--sale");
              const comp_price = document.querySelector(".price__sale .price-item--regular");
              const sticky_orig_price = document.querySelector(".product-main-sticky-bar .main-price");
              const sticky_comp_price = document.querySelector(".product-main-sticky-bar .compare-price");
              const discountPercentageEl = document.querySelector(".prestige-count");
            
              const matche_orig_price = matchedVariant.price;
              const matche_comp_price = matchedVariant.compare_at_price;
            
              if (orig_price) {
                orig_price.textContent = `${Shopify.formatMoney(matche_orig_price, Shopify.money_format).replace(/\.00$/, "")}`;
              }
            
              if (sticky_orig_price) {
                sticky_orig_price.textContent = `${Shopify.formatMoney(matche_orig_price, Shopify.money_format).replace(/\.00$/, "")}`;
              }
            
              if (comp_price) {
                if (matche_comp_price && matche_comp_price > matche_orig_price) {
                  comp_price.textContent = `${Shopify.formatMoney(matche_comp_price, Shopify.money_format).replace(/\.00$/, "")}`;
                  comp_price.style.display = "inline";
                } else {
                  comp_price.style.display = "none";
                }
              }
            
              if (sticky_comp_price) {
                if (matche_comp_price && matche_comp_price > matche_orig_price) {
                  sticky_comp_price.textContent = `${Shopify.formatMoney(matche_comp_price, Shopify.money_format).replace(/\.00$/, "")}`;
                  sticky_comp_price.style.display = "inline";
                } else {
                  sticky_comp_price.style.display = "none";
                }
              }
            
              if (discountPercentageEl) {
                if (matche_comp_price && matche_comp_price > matche_orig_price) {
                  let discount = ((matche_comp_price - matche_orig_price) * 100 / matche_comp_price).toFixed(0);
                  discountPercentageEl.textContent = `(${discount}% OFF)`;
                } else {
                  discountPercentageEl.textContent = "";
                }
              }
            }

          
            // Bind change events
            lengthInput.addEventListener("input", handleCustomChange);
            widthInput.addEventListener("input", handleCustomChange);
            handleCustomChange();
            
            // allDimensionElems.forEach((dimensionElem)=>{
            //   const dimensionVal = dimensionElem.getAttribute("data-value");
            //   if(dimensionVal == finalDimension){
            //     console.log("dimensionElem",dimensionElem);
            //     dimensionElem.click();
            //   }
            // });
            var productForm = document.querySelector(".product-form form");
            if (productForm) {
              // Remove _custom_size input if it exists
              const existingCustomSizeInput = productForm.querySelector('input[name="properties[_custom_size]"]');
              if (existingCustomSizeInput) {
                productForm.removeChild(existingCustomSizeInput);
              }
      
              // Remove _is_mto input if it exists
              const existingIsMtoInput = productForm.querySelector('input[name="properties[_is_mto]"]');
              if (existingIsMtoInput) {
                productForm.removeChild(existingIsMtoInput);
              }
            }
          }else{
            // if(pincodeInput) pincodeInput.setAttribute("data-custom",false);
             if(customWrapper) customWrapper.classList.add('hidden');
            if(dimensionOptions) dimensionOptions.classList.remove('hidden');
           
            // if(defaultBuyButton) defaultBuyButton.classList.add("active");
          }
        }
        
        const customSizeOpt = document.querySelector(".custom-size");
        if(customSizeOpt){
          customSizeOpt.addEventListener("click",function(){

          const quantityButtons = document.querySelectorAll(".quantity__button");
            quantityButtons.forEach(qtyBtn=>{
              qtyBtn.classList.remove('disabled');
              qtyBtn.removeAttribute('disabled','disabled');
            });
            this.classList.add("active");
            
            localStorage.setItem("customSize",'active');
            isCustomSize();
          });
          const checkisCustom = localStorage.getItem("customSize");
          if(checkisCustom){
            customSizeOpt.click();
          }else{
            customSizeOpt.classList.remove('active');
          }
        }
        isCustomSize();
      }
      
      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        document.body.classList.add("variant-loader");
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }
    
      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
       
      }

      renderSwatches(data) {
        const swatchValues = data.optionSwatches?.values || [];
        const variants = data.selectedVariants;
        const colorIndex = data.colorOptionIndex;
      
        if (!swatchValues.length || !variants || colorIndex == null) return '';
      
        const renderedColors = new Set();
        let swatchListHTML = ' <span class="selected_val"></span><ul class="color_option_list">';
      
        let isFirstSwatch = true;

          variants.forEach(variant => {
            const colorValue = variant[`option${colorIndex}`];
          
            if (!renderedColors.has(colorValue)) {
              const swatch = swatchValues.find(s => s.value === colorValue);
              if (!swatch) return;
          
              renderedColors.add(colorValue);
          
              let style = '';
              if (swatch.swatch_type === 'image') {
                style = `background-image:url(${swatch.swatch_value});`;
              } else if (swatch.swatch_type === 'color') {
                style = `background-color:${swatch.swatch_value};`;
              }
          
              const activeClass = isFirstSwatch ? 'active' : '';
              isFirstSwatch = false; // Only the first swatch gets 'active'
          
              swatchListHTML += `
                <li 
                  class="color_option ${activeClass}" 
                  style="${style}" 
                  data-variant-id="${variant.id}"
                  title="${colorValue}"
                  data-value="${colorValue}"
                ></li>`;
            }
          });
      
        swatchListHTML += '</ul>';
      
        const variantsJSON = JSON.stringify(variants).replace(/'/g, "&apos;"); // escape single quotes for HTML
      
        return `
          <div class="variant_list" data-options='${variantsJSON}'>
            ${swatchListHTML}
          </div>
        `;
      }

      renderAddOnWrapper(selectedVariantId) {
        if (
          !selectedVariantId ||
          !variant_related_data.hasOwnProperty(selectedVariantId) ||
          !variant_related_data[selectedVariantId]?.related_product
        ) {
          const dd_hide = document.querySelector(".addOnProducts-wrapper");
            if (dd_hide){
              dd_hide.classList.add("hidden");
            }
          return; // exit if no valid data
        }else{
          const variantData = variant_related_data[selectedVariantId];
          const data = variantData.related_product;
          console.log("data",data);
          console.log("varinats",data.selectedVariants.length);

          const swatchesHTML = this.renderSwatches(data);

          const container = document.querySelector(".addOnProducts-wrapper");
          if (!container) return;
      
          container.innerHTML = ''; // Clear previous content

          const wrapper = document.createElement('div');
          wrapper.classList.add('product_wrapper');
          wrapper.setAttribute('data-addon-id', data.selectedVariants[0]?.id);

          const firstVariant = data.selectedVariants[0];
          if(firstVariant){
              const comparePrice = firstVariant.compare_at_price;
          const salePrice = firstVariant.price;
          const discount = comparePrice && comparePrice > salePrice
            ? Math.round(((comparePrice - salePrice) / comparePrice) * 100)
            : null;

          wrapper.innerHTML = `
            <div class="title_image_wrapper flexbox align-flex-start">
              <input type="checkbox" id="addOnCheckbox" name="addOnProduct"/>
              <label for="addOnCheckbox" class="title_wrapper">
                <div class="addOn_title flexbox">
                  <span class="custom_checkbox flexbox justify-center align-center">
                    <svg class="checkmark_svg" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.80741 18C7.25636 18 7.61136 17.7999 7.86194 17.4102L17.7285 1.73782C17.9165 1.43242 18 1.20067 18 0.958407C18 0.379147 17.6137 0 17.0395 0C16.6323 0 16.3921 0.136883 16.1416 0.537152L6.76567 15.6091L1.90022 9.18434C1.63922 8.81566 1.38859 8.66822 1.00232 8.66822C0.417634 8.66822 0 9.079 0 9.6583C0 9.90052 0.10442 10.1744 0.30279 10.4272L5.72156 17.3891C6.04525 17.7999 6.35846 18 6.80741 18Z" fill="currentColor"/></svg>
                  </span>
                  <span class="custom_checkbox_text">Add a ${data.title}</span>
                </div>
                <div class="addOn_info">${data.description}</div>
                <div class="price_wrapper flexbox">
                  ${comparePrice ? `<span class="compare_price" data-compare_price="${comparePrice}">+ ₹${(comparePrice / 100).toFixed(0)}</span>` : ''}
                  <span class="sale_price" data-sale_price="${salePrice}">+ ₹${(salePrice / 100).toFixed(0)}</span>
                  ${discount ? `<span class="discount_percentage">(${discount}% OFF)</span>` : ''}
                </div>
              </label>
              <div class="image_wrapper media-box" style="--media-height: 100%;">
                ${firstVariant.image ? `<img src="${firstVariant.image}" loading="lazy">` : ''}
              </div>
            </div>
            <div class="variant_info_wrapper">
              ${swatchesHTML}
            </div>
          `;
          }
        
      
          container.appendChild(wrapper);
          // Add on products on product page
          const colorOptions = document.querySelectorAll(".addOnProducts-wrapper .color_option");
          if(colorOptions.length){
            colorOptions.forEach(option => {
              option.addEventListener("click", function () {
                document.querySelectorAll(".color_option").forEach(optionelem => {optionelem.classList.remove('active');});
                option.classList.add('active');
                const value = this.getAttribute("data-value");
                console.log("value",value);
                const selectedValEl = this.closest(".variant_list").querySelector(".selected_val");
                if (selectedValEl) {
                  selectedValEl.textContent = value;
                }
                
                let variantId = this.getAttribute("data-variant-id"); // Get selected variant ID
                let variantListWrapper = this.closest(".variant_list"); // Get parent variant list
                let productVariants = JSON.parse(variantListWrapper.getAttribute("data-options")); // Get all variants
                        
                let selectedVariant = productVariants.find(variant => variant.id == variantId);
                if (!selectedVariant) return;
                let product_wrapper = this.closest(".product_wrapper");
                if(product_wrapper){
                  product_wrapper.setAttribute("data-addon-id",variantId);
                }
             
                let imageWrapper = this.closest(".product_wrapper").querySelector(".image_wrapper img");
                // console.log("imageWrapper >>>> ",imageWrapper);
                // console.log("selectedVariant >>>> ",selectedVariant);
                // console.log("selectedVariant.featured_image",selectedVariant.image);
                if (imageWrapper && selectedVariant.image) {
                  imageWrapper.src = selectedVariant.image;
                }
            
                // Update the selected variant title
                let selectedVariantTitle = this.closest(".product_wrapper").querySelector(".selected_varinat");
                if (selectedVariantTitle) {
                  selectedVariantTitle.textContent = selectedVariant.title;
                }
            
                // Update the prices
                let priceWrapper = this.closest(".product_wrapper").querySelector(".price_wrapper");
                if (priceWrapper) {
                  let salePriceEl = priceWrapper.querySelector(".sale_price");
                  let comparePriceEl = priceWrapper.querySelector(".compare_price");
                  let discountPercentageEl = priceWrapper.querySelector(".discount_percentage");
              
                  if (salePriceEl) {
                    salePriceEl.setAttribute("data-sale_price",selectedVariant.price);
                    salePriceEl.textContent = `+ ${Shopify.formatMoney(selectedVariant.price, Shopify.money_format).replace(/\.00$/, "")}`;
                  }
              
                  if (comparePriceEl) {
                    if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
                      comparePriceEl.setAttribute("data-compare_price",selectedVariant.compare_at_price);
                      comparePriceEl.textContent = `+ ${Shopify.formatMoney(selectedVariant.compare_at_price, Shopify.money_format).replace(/\.00$/, "")}`;
                      comparePriceEl.style.display = "inline";
                    } else {
                      comparePriceEl.style.display = "none";
                    }
                  }
              
                  // Calculate and display the discount percentage
                  if (discountPercentageEl) {
                    if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
                      let discount = ((selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price).toFixed(0);
                      discountPercentageEl.textContent = `(${discount}% OFF)`;
                    } else {
                      discountPercentageEl.textContent = "";
                    }
                  }
                }
              });
            });
            const selectedColor = document.querySelector(".addOnProducts-wrapper .color_option.active").getAttribute("data-value");
            // console.log("selected Color",selectedColor);
            document.querySelector(".addOnProducts-wrapper .variant_list .selected_val").textContent = selectedColor;
          }
            
          // Add on products on product page
        }
      }

      // show personalization product if variant metafield value is set to true start
      togglePersonalizationBlock(selectedVariantId) {
        const personalizeBlock = document.querySelector(".personalize_product_block");
        if(personalizeBlock){
          const shouldShowPersonalizeBlock = window.variantMetafields?.[selectedVariantId]?.show_personalize_product;
          if (shouldShowPersonalizeBlock) {
            personalizeBlock.classList.remove("hidden");
           
          } else {
            document.querySelector(".edit_personalization_btn").click();
            document.querySelector(".personlize_button_wrapper .remove_btn").click();
            personalizeBlock.classList.add("hidden");
          }
        }
        
        const descriptionBlock = document.querySelector(".show-variant-meta-data");
        if (descriptionBlock){
          const shouldShowdescriptionBlock = window.variantMetafields?.[selectedVariantId]?.show_variant_description;
          if (shouldShowdescriptionBlock){
            descriptionBlock.classList.remove("hidden");
          }else{
            descriptionBlock.classList.add("hidden");
          }
        }
        
      }
      // show personalization product if variant metafield value is set to true end
      
      toggleVariantDescriptionSection(selectedVariantId) {
        const descriptionBlock = document.querySelector(".show-variant-meta-data");
        const descriptionText = document.querySelector(".show-var-meta-desc");
      
        if (!descriptionBlock || !descriptionText) return;
      
        const variantDescription = window.variantDescMetafields?.[selectedVariantId]?.show_variant_description;
      
        if (variantDescription && variantDescription !== "null") {
          descriptionText.textContent = variantDescription;
          descriptionBlock.classList.remove("hidden");
        } else {
          descriptionText.textContent = "";
          descriptionBlock.classList.add("hidden");
        }
      }

      getSelectedVariant(productInfoNode) {
        // console.log("productInfoNode >>>> ",productInfoNode);
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        const stickyBarButton = document.querySelector(".sticky-addtocart-btn .btn-text");
       
        // Start-----  Custom Dev 
          
        let selectedVariantVal = null;
        if (selectedVariant) {
          try {
            selectedVariantVal = JSON.parse(selectedVariant);
          } catch (error) {
            console.error("Error parsing selectedVariant HTML:", error);
          }
        }
       
        if(selectedVariantVal){
          // console.log("selectedVariantVal",selectedVariantVal);
          const customDropDown = document.querySelector(".dimension-custom-dropdown .custom-dropdown-button-text");
          if(customDropDown && customDropDown.textContent != 'Select a Size'){
             if(selectedVariantVal.available == true){
              stickyBarButton.textContent = 'Add To Cart';
              stickyBarButton.classList.add("available");
              stickyBarButton.classList.remove("sold-out");
            }else{
              stickyBarButton.textContent = 'Notify Me';
              stickyBarButton.classList.add("sold-out");
              stickyBarButton.classList.remove("available");
            }
          } 
         
         
          const selectedVariantId = selectedVariantVal.id;
          // console.log("selectedVariantId >>> ",selectedVariantId);
          this.renderAddOnWrapper(selectedVariantId);
          // call to show personalization product
          this.togglePersonalizationBlock(selectedVariantId);
          this.toggleVariantDescriptionSection(selectedVariantId);
        }
         
          const activeHeightElem = document.querySelector(".height_option.active");
          const heightVal = activeHeightElem ? activeHeightElem.getAttribute("data-value") : null;
          
          const stickyBar = document.querySelector(".product-main-sticky-bar");
          const stickyBarVariant = stickyBar.querySelector(".product-sticky-variant");
          const priceElem = stickyBar.querySelector(".main-price");
          const comparePriceElem = stickyBar.querySelector(".compare-price");
          // console.log("selectedVariantVal >>> ",selectedVariantVal);
          if (selectedVariantVal) {
           const formatOption = (option) => {
            if (!option) return option;
          
            const lower = option.toLowerCase();
          
            // Check for "x" for dimensions
            if (lower.includes('x')) {
              return `${option} inches`;
            }
          
            // Check for "pillow" and extract number
            if (lower.includes('pillow')) {
              const match = option.match(/^(\d+)\s*pillow/i);
              if (match) {
                return `pack of ${match[1]}`;
              }
            }
          
            return option;
          };
            
            const parts = [];
            const customOpt = document.querySelector(".product__info-wrapper .variant-pill-list.product-type");
            // console.log("customOpt >>> ",customOpt);
              if (customOpt) {
                const activeLink = customOpt.querySelector("a.active");
                if (activeLink) {
                  const labelText = activeLink.textContent.trim();
                  // console.log("Active Product-Type Label:", labelText);
                  if (labelText) parts.push(labelText);
                }
              }
            const checkedInput = customOpt?.querySelector("input[type='radio']:checked");
            // console.log("checkedinput",checkedInput);
            if (checkedInput) {
              console.log("checkedinput",checkedInput);
              const label = customOpt.querySelector(`label[for="${checkedInput.id}"]`);
              const labelText = label?.textContent.trim() || "";
              console.log("Checked Label:", labelText);
              if(labelText) parts.push(labelText);
            }
            
            if (selectedVariantVal.option1) parts.push(formatOption(selectedVariantVal.option1));
            if (heightVal) parts.push(`${heightVal} inch`);
            if (selectedVariantVal.option2) parts.push(formatOption(selectedVariantVal.option2));
            if (selectedVariantVal.option3) parts.push(formatOption(selectedVariantVal.option3));

            const formattedText = parts.join(' | ');
              // console.log("formattedText",formattedText);
              // stickyBarVariant.textContent = formattedText;
            const dropdownText = document.querySelector('.custom-dropdown-button-text');
            if(dropdownText){
              if (dropdownText.textContent.trim() !== 'Select a Size') {
                stickyBarVariant.textContent = formattedText;
              }
            }else{
              stickyBarVariant.textContent = formattedText;
            }
            
            priceElem.textContent = Shopify.formatMoney(selectedVariantVal.price, Shopify.money_format).replace(/\.00$/, '');
            comparePriceElem.textContent = Shopify.formatMoney(selectedVariantVal.compare_at_price, Shopify.money_format).replace(/\.00$/, '');
            // console.log("select varant get",selectedVariantVal );
          }else{
            const dropdownText = document.querySelector('.custom-dropdown-button-text');
            if(dropdownText){
              if (dropdownText.textContent.trim() == 'Select a Size') {
                const spanElement = document.createElement("span");
                spanElement.textContent = 'Select a Size!';
                spanElement.style.color = 'red';
                stickyBarVariant.replaceChildren(spanElement);
              }
            }
             // console.log("select a size setted" );
          
          }
        // end ------ Custom Dev 

        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }
        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            console.log("variant not avvailable");
           document.querySelector('.variant-pill-list.dimension input:not(.disabled)')?.click();
            document.querySelector(".variant-pill-list.pack-size input:not(.disabled)")?.click();    
            // this.setUnavailable();
            return;
          }

          // this.updateMedia(html, variant?.featured_media?.id);
          var mediaAlt =  variant?.featured_media?.alt
          this.cstUpdateMedia(mediaAlt);
           
          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          // console.log('variant sku',variant.sku);
          const delpicMsg = document.querySelector(".delivery_input_main span#delpicMsg");
          if (delpicMsg) {
            delpicMsg.innerHTML = "";
          }
          
          const pincodeInput = document.querySelector(".pincode-wrapper input#pincode");
          //AK custom code
          
          if (pincodeInput) {
             pincodeInput.setAttribute("data-sku",variant.sku);
          }
          console.log("variant",variant);
          if(variant.available){
            if (pincodeInput) {
              pincodeInput.setAttribute("data-outofstock",true)
            }
          }else{
            if (pincodeInput) {
              pincodeInput.setAttribute("data-outofstock",false)
            }
          }
          //End AK custom code

          // CUSTOM DEV
              this.sizeElems();
              let isHeightOptActive = false;
              // this.customSize();
              var defaultBuyButton = document.querySelector(".buy-buttons-block");
              const stickyBarButton = document.querySelector(".sticky-addtocart-btn .btn-text");
              var customSizeDropdown = document.querySelector(".dimension-custom-dropdown");
              const quantityButtons = document.querySelectorAll(".quantity__button");
              if(customSizeDropdown){
              // Restore the selected size after re-rendering
              const savedSize = localStorage.getItem("selectedSize");
                console.log("savedSize",savedSize);
                if (savedSize) {
                  const productInfoElem = customSizeDropdown.querySelector(".custom-dropdown-button-text");
                  if (productInfoElem) {
                    quantityButtons.forEach(qtyBtn=>{
                      qtyBtn.classList.remove('disabled');
                      qtyBtn.removeAttribute('disabled','disabled');
                    });
                    productInfoElem.textContent = savedSize + ' inches';
                    defaultBuyButton.classList.add('active');
                  
                    productInfoElem.setAttribute("data-selected",savedSize);
                  }
                }
              }
         
              const savedHeight = localStorage.getItem("selectedHeight");
              if (savedHeight) {
                // console.log("Saved Height",savedHeight);
                let savedHeightOption = document.querySelector(`.height_option[data-value="${savedHeight}"]`);
                if (savedHeightOption && !savedHeightOption.classList.contains("active")) {
                  // console.log("savedHeightOption",savedHeightOption);
                  savedHeightOption.dataset.trigger = "true"; // Dynamically set the attribute
                  savedHeightOption.click(); // Simulate the click
                  isHeightOptActive = true;
                  // console.log("height option triggered...1");
                }
              }

              // Add a delay before resetting the "Select a Size" text
              setTimeout(() => {
                document.querySelectorAll(".category .variant-pill, .choose-your-type .variant-pill").forEach(variantPill => {
                  variantPill.addEventListener("click", function () {
                    const atcBtns = document.querySelectorAll(".atc-button");
                    const stickyBar = document.querySelector(".product-main-sticky-bar");
                    if(atcBtns.length){
                      atcBtns.forEach(atcBtn => {
                        if(atcBtn.classList.contains('hidden')){
                          atcBtn.classList.remove('hidden');
                        }
                      });
                      stickyBar.classList.remove('hidden')
                    }

                  const customSizeOpt = document.querySelector(".custom-size");
                  if(customSizeOpt) customSizeOpt.classList.remove('active');
                    localStorage.removeItem("customSize");
                    
                    // console.log("variantPill >>>> ",variantPill);
                    const productInfoElem = document.querySelector(".custom-dropdown-button-text");
                    if (productInfoElem) {
                      const heightOption = document.querySelector(".variant-pill-list.height");
                      if(heightOption){
                        productInfoElem.removeAttribute("data-selected");
                        productInfoElem.textContent = "Select a Size";
                        quantityButtons.forEach(qtyBtn=>{
                          qtyBtn.classList.add('disabled');
                          qtyBtn.setAttribute('disabled','disabled');
                        });
                      }

                      const dd_hide = document.querySelector(".addOnProducts-wrapper");
                      if (dd_hide){
                        dd_hide.classList.add("hidden");
                      }
                      
                      localStorage.removeItem("selectedSize");
                      defaultBuyButton.classList.remove('active');
                      stickyBarButton.textContent = 'Select Size';
                    }
                  });
                });
              }, 100); // 100ms delay (adjust if needed)
          setTimeout(()=>{
             this.sizeConverter();
          },500);
            // CUSTOM DEV

              
          
            setTimeout(()=>{
              const visibleDimensionInputs = document.querySelectorAll(
                '.dimension .variant-pill:not(.hidden) input[type="radio"]'
              );
      
              // console.log("visibleDimensionInputs",visibleDimensionInputs);
              // 2. Extract unique height values from dimension inputs
              const heightSet = new Set();
            
              visibleDimensionInputs.forEach(input => {
                const value = input.value.trim(); // "78 x 36 x 10"
                const parts = value.split("x").map(p => p.trim());
                const height = parts[parts.length - 1]; // Get "10"
                if (height) {
                  heightSet.add(height);
                }
              });
              console.log("heightSet",heightSet);
              var heightOptions = document.querySelectorAll(".product-form__input.height .height_option");
              heightOptions.forEach(option => {
                const value = option.getAttribute("data-value");
                if (heightSet.has(value)) {
                  option.closest(".variant-pill").classList.remove("hidden");
                  option.classList.remove("hidden");
                } else {
                  option.classList.add("hidden");
                  option.closest(".variant-pill").classList.add("hidden");
                }
              });
              
              let savedHeightOption = document.querySelector(`.height_option[data-value="${savedHeight}"]`);
            
              // console.log("savedHeightOption",savedHeightOption);
              if ((savedHeightOption === null || savedHeightOption.classList.contains("hidden")) && !isHeightOptActive) {
                const firstVisibleOption = document.querySelector(".height_option:not(.hidden)");
                firstVisibleOption?.click();
                console.log("height option triggered...2");
              }
              
              // If some height option was already marked active
              if (isHeightOptActive) {
                const activeOption = document.querySelector(".height_option.active");
              
                if (activeOption && activeOption.classList.contains("hidden")) {
                  // Active option is hidden — fallback to first visible one
                  const firstVisibleOption = document.querySelector(".height_option:not(.hidden)");
                  if (firstVisibleOption) {
                    firstVisibleOption.click();
                    console.log("height option triggered...3 — active was hidden");
                  }
                }
              }
            },500);
           document.body.classList.remove("variant-loader");
        };
        
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        // const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
        //   .map((id) => `#${id}-${this.dataset.section}`)
        //   .join(', ');
        const selectors = ['Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      // default function is commented
      updateMedia(html, variantFeaturedMediaId) {
       if (!variantFeaturedMediaId) return;      
        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      cstUpdateMedia(data_media_alt){
        // console.log("data media alt",data_media_alt);
        let mainSlider, thumbnailSlider; // Declare Swiper instances globally
        const zoomView = document.getElementById('zoomView');

        function updateZoomFromActiveSlide() {
          // const zoomView = document.getElementById('zoomView');
          if(zoomView){
             // Optional: CSS hidden initially
            zoomView.style.display = 'none';
            document.addEventListener('mouseover', function (e) {
              if (e.target instanceof Element && e.target.closest('.main-slider .swiper-slide-active img')) {
                const activeImg = e.target;
                const zoomImg = activeImg.getAttribute('data-zoom') || activeImg.src;
            
                zoomView.style.backgroundImage = `url(${zoomImg})`;
                zoomView.classList.remove("hidden");
                zoomView.style.display = 'block';
                
            
                function handleMouseMove(ev) {
                  const rect = activeImg.getBoundingClientRect();
                  const x = ev.clientX - rect.left;
                  const y = ev.clientY - rect.top;
                  const xPercent = (x / rect.width) * 100;
                  const yPercent = (y / rect.height) * 100;
            
                  zoomView.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
                }
            
                function handleMouseLeave() {
                  zoomView.style.display = 'none';
                  zoomView.style.backgroundImage = '';
                  activeImg.removeEventListener('mousemove', handleMouseMove);
                  activeImg.removeEventListener('mouseleave', handleMouseLeave);
                }
                activeImg.addEventListener('mousemove', handleMouseMove);
                activeImg.addEventListener('mouseleave', handleMouseLeave);
              }
            }, true);
          }
        }
        
        // function mainPDPSlider() {
        //     let mainSlider, thumbnailSlider; 
        //   if (document.querySelector('.main-slider')?.swiper) {
        //     document.querySelector('.main-slider').swiper.destroy(true, true);
        //   }
        //   if (document.querySelector('.thumbnail-slider')?.swiper) {
        //     document.querySelector('.thumbnail-slider').swiper.destroy(true, true);
        //   }
      
        //   const totalThumbSlides = document.querySelectorAll('.thumbnail-slider .swiper-slide').length;
      
        //   function getCurrentSlidesPerView() {
        //     const width = window.innerWidth;
        //     if (width >= 1260) return 5;
        //     if (width >= 1080) return 5;
        //     if (width >= 575) return 4;
        //     return 3;
        //   }
      
        //   const currentSlidesPerView = getCurrentSlidesPerView();
        //   const useLoopAndCentering = totalThumbSlides > currentSlidesPerView;
      
        //   mainSlider = new Swiper('.main-slider', {
        //     slidesPerView: 1,
        //     spaceBetween: 0,
        //     autoHeight: true,
        //     loop: useLoopAndCentering,
        //     pagination: {
        //       el: '.product-hero-section .swiper-pagination',
        //       clickable: true
        //     },
        //     navigation: {
        //       nextEl: '.product-hero-section .swiper-button-next',
        //       prevEl: '.product-hero-section .swiper-button-prev',
        //     }
        //   });
      
        //   thumbnailSlider = new Swiper('.thumbnail-slider', {
        //     slidesPerView: 3,
        //     spaceBetween: 10,
        //     slideToClickedSlide: true,
        //     loop: useLoopAndCentering,
        //     centeredSlides: useLoopAndCentering,
        //     centeredSlidesBounds: useLoopAndCentering,
        //     watchSlidesProgress: true,
        //     watchSlidesVisibility: true,
        //     breakpoints: {
        //       575: { slidesPerView: 4 },
        //       1080: { slidesPerView: 5 },
        //       1260: { slidesPerView: 5 }
        //     }
        //   });
      
        //   // Force initial sync
        //   const initialIndex = 0;
      
        //   if (useLoopAndCentering) {
        //     mainSlider.slideToLoop(initialIndex, 0, false);
        //     thumbnailSlider.slideToLoop(initialIndex, 0, false);
        //     const mediaId = document.querySelector(".pdp-main-slider-wrap .swiper-slide.swiper-slide-active")?.getAttribute("data-media-id");
        //     const matchedElem = document.querySelector(`.product-gallery__thumbnail-list [data-media-id="${mediaId}"]`);
        //    console.log("matchedElem",matchedElem);
        //      let matchedIndex = -1;
        //       thumbnailSlider.slides.forEach((slide, index) => {
        //         if(slide.getAttribute("data-media-id") == mediaId){
        //           matchedIndex = index;
        //         }
        //       });
        //     console.log("matchedIndex",matchedIndex);

           
      
        //     // Fix active state
        //     thumbnailSlider.slides.forEach(slide => {
        //       const slideIndex = parseInt(slide.getAttribute('data-swiper-slide-index'));
        //       slide.classList.toggle('swiper-slide-active', slideIndex === initialIndex);
        //     });
      
        //     thumbnailSlider.on('click', (swiper) => {
        //       const clickedSlide = swiper.clickedSlide;
        //       if (!clickedSlide) return;
        //       const realIndex = parseInt(clickedSlide.getAttribute('data-swiper-slide-index'));
        //       if (!isNaN(realIndex)) {
        //         mainSlider.slideToLoop(realIndex);
        //       }
        //     });
      
        //     mainSlider.on('slideChange', () => {
        //       const realIndex = mainSlider.realIndex;
        //       thumbnailSlider.slideToLoop(realIndex);
        //       updateThumbnailActiveClass(realIndex);
        //     });
      
        //     function updateThumbnailActiveClass(realIndex) {
        //       thumbnailSlider.slides.forEach((slide) => {
        //         const slideIndex = parseInt(slide.getAttribute('data-swiper-slide-index'));
        //         slide.classList.toggle('swiper-slide-active', slideIndex === realIndex);
        //       });
        //     }
      
        //   } else {
        //     mainSlider.slideTo(initialIndex, 0, false);
        //     thumbnailSlider.slideTo(initialIndex, 0, false);
      
        //     thumbnailSlider.slides.forEach((slide, index) => {
        //       slide.classList.toggle('swiper-slide-active', index === initialIndex);
        //     });
      
        //     thumbnailSlider.on('click', (swiper) => {
        //       const clickedIndex = swiper.clickedIndex;
        //       mainSlider.slideTo(clickedIndex);
        //       updateThumbnailActiveClassSimple(clickedIndex);
        //     });
      
        //     mainSlider.on('slideChange', () => {
        //       const activeIndex = mainSlider.activeIndex;
        //       thumbnailSlider.slideTo(activeIndex);
        //       updateThumbnailActiveClassSimple(activeIndex);
        //     });
      
        //     function updateThumbnailActiveClassSimple(activeIndex) {
        //       thumbnailSlider.slides.forEach((slide, index) => {
        //         slide.classList.toggle('swiper-slide-active', index === activeIndex);
        //       });
        //     }
        //   }
        // }
        function mainPDPSlider() {
          const mainSliderEl = document.querySelector('.main-slider');
          const thumbSliderEl = document.querySelector('.thumbnail-slider');
        
          if (mainSliderEl?.swiper) mainSliderEl.swiper.destroy(true, true);
          if (thumbSliderEl?.swiper) thumbSliderEl.swiper.destroy(true, true);
        
          const mainSlider = new Swiper('.main-slider', {
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: true,
            pagination: {
              el: '.product-hero-section .swiper-pagination',
              clickable: true
            },
            navigation: {
              nextEl: '.product-hero-section .swiper-button-next',
              prevEl: '.product-hero-section .swiper-button-prev',
            }
          });
        
          const thumbnailSlider = new Swiper('.thumbnail-slider', {
            slidesPerView: 3,
            spaceBetween: 10,
            slideToClickedSlide: false,
            breakpoints: {
              575: {
                spaceBetween: 10,
                slidesPerView: 4
              },
              1081: {
                spaceBetween: 20,
                slidesPerView: 5
              }
            }
          });
        
          function updateThumbnailActiveClass(activeIndex) {
            thumbnailSlider.slides.forEach((slide, index) => {
              const isActive = index === activeIndex;
              slide.classList.toggle('swiper-slide-active', isActive); // add/remove swiper-slide-active
              slide.classList.toggle('slide-active', isActive);        // add/remove custom slide-active
            });
        
            const offsetIndex = Math.max(activeIndex - 1, 0);
            thumbnailSlider.slideTo(offsetIndex);
          }
        
          thumbnailSlider.on('click', (swiper) => {
            const clickedIndex = swiper.clickedIndex;
            mainSlider.slideTo(clickedIndex);
            updateThumbnailActiveClass(clickedIndex);
          });
        
          mainSlider.on('slideChange', () => {
            const activeIndex = mainSlider.activeIndex;
            updateThumbnailActiveClass(activeIndex);
          });
        
          // Initial sync
          updateThumbnailActiveClass(mainSlider.activeIndex);
        }




  
        // console.log("data_media_alt",data_media_alt);
    
        
          let matchFound = false;

          if (data_media_alt) {
            const altValues = data_media_alt.split('\n').map(str => str.trim().toLowerCase()); // Break into lines
            // console.log("altValues >>> ",altValues);
            const elements = document.querySelectorAll("[data-media-alt]");
            elements.forEach(element => {
              const dataValue = element.getAttribute("data-media-alt")?.trim().toLowerCase();
         
              // Check if any alt value matches this element's data-media-alt (fully or partially)
              const isMatch = altValues.some(alt => dataValue.includes(alt));
       
              if (!dataValue.includes('all')) {
                if (isMatch) {
                  matchFound = true;
                  element.classList.remove("non-swiper-slide", "hidden");
                  element.classList.add("swiper-slide");
                } else {
                  element.classList.add("non-swiper-slide", "hidden");
                  element.classList.remove("swiper-slide");
                }
              }
            });
            // mainPDPSlider();
            console.log("matchfound >> ",matchFound);
          }
        
        setTimeout(function(){
          mainPDPSlider();
          if(zoomView){
            updateZoomFromActiveSlide();
          }
        },50);

        let youtubePlayers = {};

        function loadYouTubeAPI() {
          if (window.YT && YT.Player) {
            initializeYouTubePlayers();
          } else {
            const tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(tag);
            window.onYouTubeIframeAPIReady = initializeYouTubePlayers;
          }
        }
      
        function initializeYouTubePlayers() {
          document.querySelectorAll(".youtube-lazy").forEach(wrapper => {
            const playButton = wrapper.querySelector(".youtube-play-button");
            const videoId = wrapper.dataset.videoId;
            const wrapperId = wrapper.id;
      
            if (!playButton || !videoId || !wrapperId) return;
      
            playButton.addEventListener("click", function () {
              wrapper.innerHTML = `<div id="${wrapperId}-player"></div>`;
      
              youtubePlayers[wrapperId] = new YT.Player(`${wrapperId}-player`, {
                videoId: videoId,
                playerVars: {
                  autoplay: 1,
                  rel: 0,
                  modestbranding: 1,
                  controls: 1
                },
                events: {
                  onStateChange: (event) => {
                    const player = event.target;
      
                    // ✅ Handle video END
                    if (event.data === YT.PlayerState.ENDED) {
                      restorePoster(wrapper, videoId, wrapperId);
                    }
      
                    // ✅ Handle PAUSE (center click or play/pause)
                    if (event.data === YT.PlayerState.PAUSED) {
                      setTimeout(() => {
                        const state = player.getPlayerState();
                        const currentTime = player.getCurrentTime();
                        const duration = player.getDuration();
      
                        const nearStart = currentTime < 1;
                        const nearEnd = currentTime > duration - 1;
      
                        // Restore if still paused after short time
                        if (state === YT.PlayerState.PAUSED && (nearStart || nearEnd || true)) {
                          restorePoster(wrapper, videoId, wrapperId);
                        }
                      }, 500);
                    }
                  }
                }
              });
            });
          });
        }
      
        function restorePoster(wrapper, videoId, wrapperId) {
          wrapper.innerHTML = `
            <div class="youtube-poster flexbox align-center justify-center" style="background-image: url('https://img.youtube.com/vi/${videoId}/hqdefault.jpg')">
              <button class="youtube-play-button yt-lazyload-playbtn" aria-label="Play Video">
                <svg class="icon icon--pdp_youtube_play_icon " width="68" height="48" viewBox="0 0 68 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M66.52 7.74C65.74 4.81 64.03 2.33 61.1 1.55C55.79 0.13 34 0 34 0C34 0 12.21 0.13 6.9 1.55C3.97 2.33 2.27 4.81 1.48 7.74C0.0600001 13.05 0 24 0 24C0 24 0.0600001 34.95 1.48 40.26C2.26 43.19 3.97 45.67 6.9 46.45C12.21 47.87 34 48 34 48C34 48 55.79 47.87 61.1 46.45C64.03 45.67 65.74 43.19 66.52 40.26C67.94 34.95 68 24 68 24C68 24 67.94 13.05 66.52 7.74Z" fill="currentColor"></path>
                  <path d="M45 24L27 14V34" fill="white"></path>
                </svg>
              </button>
            </div>
          `;
          initializeYouTubePlayers(); // Rebind play button
        }
        loadYouTubeAPI();
        document.addEventListener("DOMContentLoaded", loadYouTubeAPI);
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner')?.classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner')?.classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
